import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const modalCloseListener = (modalId, callback) => {
  const modalElement = document.getElementById(modalId);

  if (!modalElement) {
    console.error(`Modal with ID "${modalId}" not found.`);
    return;
  }

  const handleModalClose = () => {
    callback();
  };

  modalElement.addEventListener("hidden.bs.modal", handleModalClose);

  // Return a cleanup function to remove the event listener
  return () => {
    modalElement.removeEventListener("hidden.bs.modal", handleModalClose);
  };
};

// *For Generate PDF
export const generatePdf = async (ref) => {
  try {
    const canvas = await html2canvas(ref, {
      scale: 1.5,
      scrollX: 0,
      scrollY: 0,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/jpeg", 1);
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'pt',
      format: 'a4'
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    // Calculate image scaling to fit within A4 dimensions
    const ratio = Math.min(pdfWidth / canvasWidth, pdfHeight / canvasHeight);
    const imgWidth = canvasWidth * ratio;
    const imgHeight = canvasHeight * ratio;

    // Content positioning
    const xOffset = 0
    const yOffset = 0

    pdf.addImage(imgData, "JPEG", xOffset, yOffset, imgWidth, imgHeight);

    const blob = pdf.output("blob");
    const blobURL = URL.createObjectURL(blob);
    const newWindow = window.open('', '_blank');

    if (newWindow) {
      newWindow.document.write(`
      <html>
        <head>
          <title>Sale Invoice</title>
        </head>
        <body style="margin:0">
          <iframe src="${blobURL}" style="width:100%;height:100vh;border:none;" onload="this.contentWindow.print()"></iframe>
        </body>
      </html>
    `);
      newWindow.document.close();
    }
  } catch (error) {
    console.log(' generatePdf => error:', error)
  }
};

// *Convert a Number into Words
export const numberToWords = (numberString) => {
  const numberToText = (num) => {
    const belowTwenty = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
      'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const tens = [
      '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
    ];
    const thousands = ['', 'Thousand', 'Million', 'Billion'];

    if (num === 0) return 'Zero';

    let word = '';
    let groupIndex = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        word = helper(num % 1000) + thousands[groupIndex] + ' ' + word;
      }
      num = Math.floor(num / 1000);
      groupIndex++;
    }

    return word.trim();

    function helper(n) {
      if (n === 0) return '';
      if (n < 20) return belowTwenty[n] + ' ';
      if (n < 100) return tens[Math.floor(n / 10)] + ' ' + helper(n % 10);
      return belowTwenty[Math.floor(n / 100)] + ' Hundred ' + helper(n % 100);
    }
  };

  // Parse as a float
  const cleanNumber = parseFloat(numberString);

  if (isNaN(cleanNumber)) {
    return 'Invalid number';
  }

  // Split into integer (Rupees) and fractional (Paisa)
  const [integerPart, fractionalPart] = cleanNumber.toFixed(2).split('.');

  const integerWords = numberToText(parseInt(integerPart, 10)) + ' Rupees';

  let fractionalWords = '';
  if (fractionalPart && parseInt(fractionalPart, 10) > 0) {
    fractionalWords = ' and ' + numberToText(parseInt(fractionalPart, 10)) + ' Paisa';
  }

  return (integerWords + fractionalWords).trim();
};

